import {
  getRelativePath,
  toggleClass,
  toggleHeight,
  closeSelect,
  openSelect,
  clearInputByName,
  selectValue,
  handleScroll,
  doublePullDown,
  changeTabRadio,
  clearAllInput,
  togglePasswordVisibility,
  toggleEllipsisClass,
  toggleSnackbar,
  searchForm,
  favButton,
  incomingMailButton,
  addFavoriteCartDeleteClass,
  getIncomingMailRegistCount,
  createReserveRegion,
  deleteSuggestWord,
  deleteAllSuggestWord,
  bulkGoAction,
  selectAddressValue,
} from './functions/utilityFunctions';

import { productSlider, productSliderLarge } from './functions/splideSlider';

document.addEventListener('DOMContentLoaded', () => {
  let lastScroll = 0;
  // 商品スライダー
  productSlider();
  productSliderLarge();

  // 検索窓の挙動
  searchForm();

  // 検索履歴全消去ボタン
  const allSuggestDeleteButton = document.querySelectorAll('.js-suggest-delete-all');
  allSuggestDeleteButton.forEach((el) => {
    el.addEventListener('click', () => {
      deleteAllSuggestWord();
    });
  });

  // ヘッダーの検索初期値を設定
  const headerCatSelect = document.querySelectorAll('.js-init-category');
  headerCatSelect.forEach((el) => {
    const initialValue = el.getAttribute('data-value');

    if (initialValue) {
      selectValue('cname');
    }
  });

  // プルダウン
  const pullDownButton = document.querySelectorAll('.js-pullDown');
  if (pullDownButton.length > 0) {
    pullDownButton.forEach((button) => {
      toggleHeight(button, 0);
    });
  }
  // クラスのトグル
  const toggleButton = document.querySelectorAll('.js-toggle');
  if (toggleButton.length > 0) {
    toggleButton.forEach((button) => {
      toggleClass(button, true);
    });
  }
  // 解除可能ラジオボタン
  const toggleRadio = document.querySelectorAll('.js-toggle-radio');
  if (toggleRadio.length > 0) {
    toggleRadio.forEach((radio) => {
      // data-onに初期値セット
      radio.dataset.on = radio.checked;
      radio.addEventListener('click', (e) => {
        // data-onがtrueだったらONの状態でclickした
        if (radio.dataset.on && radio.dataset.on === 'true') {
          radio.checked = false;
          radio.dataset.on = false;
        } else {
          radio.checked = true;
          radio.dataset.on = true;
          // 他のradioのチェックは全てOFF
          Array.from(toggleRadio)
            .filter((r) => r !== radio)
            .forEach((bro) => {
              bro.dataset.on = false;
            });
        }
      });
    });
  }

  // スナックバー
  const snackbarEvent = document.querySelectorAll('.js-snackbar');
  if (snackbarEvent.length > 0) {
    snackbarEvent.forEach((button) => {
      toggleSnackbar(button);
    });
  }
  // セレクトボックス
  const observer = new MutationObserver((mutationList, observer) => {
    mutationList.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.matches('.js-select')) {
              closeSelect(node);
            }
            node.querySelectorAll('.js-select').forEach((element) => {
              closeSelect(element);
            });

            if (node.matches('.js-selectLabel')) {
              openSelect(node);
            }
            node.querySelectorAll('.js-selectLabel').forEach((element) => {
              openSelect(element);
            });

            if (node.matches('.js-selectOption')) {
              node.addEventListener('change', (event) => {
                const name = node.getAttribute('name');
                selectValue(name);
              });
            }
            node.querySelectorAll('.js-selectOption').forEach((element) => {
              element.addEventListener('change', (event) => {
                const name = element.getAttribute('name');
                selectValue(name);
              });
            });
          }
        });
      }
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
  const select = document.querySelectorAll('.js-select');
  if (select.length > 0) {
    select.forEach((element) => {
      closeSelect(element);
    });
  }
  const selectLabel = document.querySelectorAll('.js-selectLabel');
  if (selectLabel.length > 0) {
    selectLabel.forEach((element) => {
      openSelect(element);
    });
  }
  const selectOption = document.querySelectorAll('.js-selectOption');
  if (selectOption.length > 0) {
    selectOption.forEach((element) => {
      element.addEventListener('change', (event) => {
        const name = element.getAttribute('name');
        selectValue(name);
      });
    });
  }

  const selectMultipleAddressOptions = document.querySelectorAll('.js-selectOption-address');
  if (selectMultipleAddressOptions.length > 0) {
    selectMultipleAddressOptions.forEach((element) => {
      element.addEventListener('change', (event) => {
        const container = element.closest('.js-addressContainer');
        const name = element.getAttribute('name');
        selectAddressValue(container, name);
      });
    });
  }

  // フォームのクリア
  const clearInputButton = document.querySelectorAll('.js-clearInput');
  if (clearInputButton.length > 0) {
    clearInputButton.forEach((element) => {
      clearInputByName(element);
    });
  }
  // 二重のプルダウン
  const pullDown = document.querySelectorAll('.js-doublePullDownCommon');
  if (pullDown.length) {
    pullDown.forEach((element) => {
      const targetId = element.getAttribute('data-target');
      const height = element.getAttribute('data-height') || 0;
      const target = document.getElementById(targetId);

      doublePullDown(element, height);
    });
  }
  // ラジオボタンのタブ切り替え
  const tabRadioButton = document.querySelectorAll('.js-tabRadio');
  if (tabRadioButton.length > 0) {
    tabRadioButton.forEach((button) => {
      changeTabRadio(button);
    });
  }
  // 全フォームのクリア
  const clearAllInputButton = document.querySelectorAll('.js-clearAllInput');
  if (clearAllInputButton) {
    clearAllInputButton.forEach((button) => {
      button.addEventListener('click', () => {
        const targetForm = button.getAttribute('data-target');
        const target = document.getElementById(targetForm);
        clearAllInput(target);
      });
    });
  }
  // パスワードの表示/非表示切り替え
  const passwordVisibilityButton = document.querySelectorAll('.js-passwordVisibilityButton');
  if (passwordVisibilityButton.length > 0) {
    passwordVisibilityButton.forEach((button) => {
      button.addEventListener('click', () => {
        const passwordInputTarget = button.getAttribute('data-target');
        const passwordInput = document.getElementById(passwordInputTarget);
        togglePasswordVisibility(button, passwordInput);
      });
    });
  }
  const toggleEllipsisButton = document.querySelector('.js-ellipsis');
  if (toggleEllipsisButton) {
    const targetId = toggleEllipsisButton.getAttribute('data-target');
    toggleEllipsisClass(targetId, toggleEllipsisButton);
  }

  // 入荷メール登録者数取得処理
  const incomingMailCountButton = document.querySelectorAll('.js-incomingMailCount');
  incomingMailCountButton.forEach((el) => {
    getIncomingMailRegistCount(el);
    createReserveRegion(el);
  });

  // 入荷メール登録ボタン
  const incomingMailButtons = document.querySelectorAll('.js-incomingMailButton');
  incomingMailButtons.forEach((el) => {
    incomingMailButton(el);
  });

  // カート追加、お気に入り登録ボタン
  const addFavoriteCartDeleteButton = document.querySelectorAll('.js-addFavoriteCartDelete');
  addFavoriteCartDeleteButton.forEach((el) => {
    addFavoriteCartDeleteClass(el);
  });

  // お気に入り登録/削除ボタン
  const favButtons = document.querySelectorAll('.js-favorite-button');
  favButtons.forEach((el) => {
    favButton(el);
  });

  // 絞り込みモーダル価格帯
  const filterModalPrice = document.querySelectorAll('.js_filter_modal_price');
  filterModalPrice.forEach((el) => {
    el.addEventListener('click', (event) => {
      el.checked = false;
      const container = el.closest('.js_filter_modal_price_container');
      const [minPrice, maxPrice] = el.value.split('_');
      container.querySelector('input[name=filter_price_min]').value = minPrice === '0' ? '' : minPrice;
      container.querySelector('input[name=filter_price_max]').value = maxPrice === '0' ? '' : maxPrice;
    });
  });

  // ヘッダーのスクロール挙動に伴うアニメーション
  window.addEventListener('scroll', () => {
    lastScroll = handleScroll(lastScroll);
  });

  // 一括登録ボタン
  const bulkButton = document.querySelectorAll('.js-bulk-button');
  if (bulkButton.length > 0) {
    bulkButton.forEach((button) => {
      button.addEventListener('click', (e) => {
        button.disabled = true;
        const action = document.querySelector('input[name="bulkcheck-action"]:checked').dataset.value;
        let cmdtyCodes = [];
        let anyNoStocked = false;
        const targetElements = document.querySelectorAll('.js-checkbox-item:checked');
        if (targetElements.length === 0) {
          // alert('商品を選択してください。');
          let message = '商品を選択してください。';
          const snackbar = document.getElementById('js-snack-common');
          if (snackbar) {
            snackbar.querySelector('.c-snackbar__text').innerHTML = message;
            // is-activeクラスをトグル
            snackbar.classList.add('is-active');
          }
          button.disabled = false;
          return;
        }
        targetElements.forEach((element) => {
          cmdtyCodes.push(element.value);
          if (!anyNoStocked) {
            anyNoStocked = element.dataset.stock == 0;
          }
        });
        if (action === 'cart' && anyNoStocked) {
          //alert('在庫のない商品はカートに入れることができません。\nチェックした商品の在庫をご確認ください。');
          let message = '在庫のない商品はカートに入れることができません。\nチェックした商品の在庫をご確認ください。';
          const snackbar = document.getElementById('js-snack-common');
          if (snackbar) {
            snackbar.querySelector('.c-snackbar__text').innerHTML = message;
            // is-activeクラスをトグル
            snackbar.classList.add('is-active');
          }
          button.disabled = false;
          return;
        }
        bulkGoAction(
          action,
          cmdtyCodes,
          (message) => {
            // 共通スナックバー
            const snackbar = document.getElementById('js-snack-common');
            // スナックバーが存在する場合
            if (snackbar) {
              snackbar.querySelector('.c-snackbar__text').innerHTML = message;
              // is-activeクラスをトグル
              snackbar.classList.add('is-active');

              // スナックバーを閉じるボタンがクリックされたら非表示にする
              const closeButton = snackbar.querySelector('.js-snackbar');
              if (closeButton) {
                closeButton.addEventListener('click', () => {
                  snackbar.classList.remove('is-active');
                });
              }
              // 削除系は商品カセットを非表示にする
              if (action === 'delete-fav' || action === 'delete-incomingmail') {
                targetElements.forEach((ele) => {
                  ele.closest('.l-myfavorite__list').style.display = 'none';
                });
              }
              button.disabled = false;
            }
          },
          (err) => {
            button.disabled = false;
          },
        );
      });
    });
  }

  // スナックバーを5秒後に非表示
  const snackbar = document.querySelectorAll('.c-snackbar');
  if (snackbar.length > 0) {
    const snackbarTimeouts = new Map();

    const closeSnackbar = (mutationList) => {
      for (let mutation of mutationList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class' && mutation.target.classList.contains('is-active')) {
          const element = mutation.target;

          const closeTime = element.getAttribute('data-close-time') ?? '5000';

          if (snackbarTimeouts.has(element)) {
            clearTimeout(snackbarTimeouts.get(element));
          }

          const timeoutId = setTimeout(() => {
            element.classList.remove('is-active');
            snackbarTimeouts.delete(element);
          }, parseInt(closeTime));

          snackbarTimeouts.set(element, timeoutId);
        }
      }
    };

    // 閉じるボタン押下でsetTimeoutを解除
    const snackbarObserver = new MutationObserver(closeSnackbar);
    snackbar.forEach((snackbar) => {
      snackbarObserver.observe(snackbar, { attributes: true });

      const closeButton = snackbar.querySelector('.c-snackbar__close');
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          if (snackbarTimeouts.has(snackbar)) {
            clearTimeout(snackbarTimeouts.get(snackbar));
            snackbarTimeouts.delete(snackbar);
          }
        });
      }
    });
  }

  // const rakutenAgreementForm = document.querySelectorAll('.js-rakuten-agreement-form');
  // rakutenAgreementForm.forEach((el) => {
  //   el.addEventListener('submit', async (event) => {
  //     event.preventDefault();

  //     // ログイン状態の確認
  //     const isSessionLogin = await checkSessionLogin();

  //     // 非Session認証ログインの場合、ログイン画面へ遷移
  //     if (!isSessionLogin) {
  //       location.href = '/login/';
  //       return;
  //     }

  //     // Session認証ログイン済みの場合、フォーム送信
  //     el.submit();
  //   });
  // });

  // const vAgreementLink = document.querySelectorAll('.js-v-agreement-link');
  // vAgreementLink.forEach((el) => {
  //   el.addEventListener('click', async (event) => {
  //     event.preventDefault();

  //     // ログイン状態の確認
  //     const isSessionLogin = await checkSessionLogin();

  //     // 非Session認証ログインの場合、ログイン画面へ遷移
  //     if (!isSessionLogin) {
  //       location.href = '/login/';
  //       return;
  //     }

  //     // 元のhrefへ遷移
  //     const href = el.getAttribute('href');
  //     if (href) {
  //       location.href = href;
  //     }

  //     return;
  //   });
  // });

  const checkSessionLogin = async () => {
    let isSessionLogin = false;
    try {
      const response = await fetch('/api/getAuthStatus/');
      const data = await response.json();
      isSessionLogin = response.ok && data.status === '02'; // Session認証ログインか否か
    } catch (error) {
      console.error('ログイン状態が取得できません:', error);
      isSessionLogin = false;
    }

    return isSessionLogin;
  };
});
